import React from "react";
import SideBarV1 from "../NewDashboard/SideBarV1";
import SatLogo from "../../assets/Images/SATprep1.svg";
import DashboardBackground from "../../components/ReUsableComponents/DashboardBackground";
import FullMarksLoader from "../../components/ReUsableComponents/FullMarksLoader";
import { ResultTab } from "./ResultPageTabs";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store/store";
import { getItem } from "../../utils/token";
import { useGetUserResultsQuery } from "../../redux/API/StartTest/startTestApi";

const ParentResults = () => {

  const { parentStudentId } = useSelector((state: RootState) => state.root.startFullTest);

  const studentId = getItem('studentId');

  const { data: resultData, isLoading: isResultLoading, refetch: refetchResultsData } = useGetUserResultsQuery(parentStudentId ? parentStudentId : studentId, { refetchOnMountOrArgChange: true });

  return (
    <>
      {" "}
      <DashboardBackground>
        <div className="p-5 flex gap-[1%] w-full">
          {/* Sidebar */}
          <SideBarV1 />

          <section
            className="flex flex-col justify-center items-start gap-[2vh]"
            style={{
              width: "calc(100vw - 240px)",
              height: "calc(100vh - 40px)",
            }}
          >
            <div className="p-3 max-h-[10vh] min-h-[98px] flex justify-center items-center self-stretch rounded-[28px] border-[0.5px] border-satPrepGrey bg-satPrepTransWhite shadow-widget-card backdrop-blur-sevenFive">
              <img
                src={SatLogo}
                alt="Sat-Logo"
                className="w-[223px] h-[72px] mt-2"
              />
            </div>

            <div
              className="py-2 px-4 w-full flex flex-grow justify-between items-center self-stretch rounded-[28px] border-[0.5px]  border-satPrepGrey bg-satPrepTransWhite shadow-widget-card backdrop-blur-sevenFive"
              style={{ height: "calc(100vh - 12vh - 40px)" }}
            >
              <div className="h-full py-2 w-full">
                <ResultTab
                  resultData={resultData?.data}
                  isLoading={isResultLoading}
                />
              </div>
            </div>
          </section>
        </div>
      </DashboardBackground>
    </>
  );
};

export default ParentResults;
